export const wrapArr = <A>(
  a: A | A[] | ReadonlyArray<A>
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
): ReadonlyArray<A> => Array.isArray(a) ? a : [a as A];
